import {Button} from '@/ui-kit';
import styles from './load-more-button.module.scss';

export const LoadMoreButton = ({loading, onClick}) => (
  <div className={styles.loadMore}>
    <Button type="secondary" onClick={onClick} loading={loading}>
      Load More
    </Button>
  </div>
);
